@if (vm$ | async; as vm) {
  <div class="shell">
    <header class="masthead">
      <div class="masthead-identity">
        <h1 class="masthead-mark">Atlas</h1>
        <p class="masthead-rollcall">{{ vm.rollCall }}</p>
      </div>
      <div class="masthead-controls">
        @if (vm.lastCheckedAt; as stamp) {
          <span class="masthead-stamp">Checked {{ stamp | date: 'HH:mm:ss' }}</span>
        }
        <button type="button" class="button" (click)="refreshAll()" [disabled]="vm.isSweeping">
          {{ vm.isSweeping ? 'Checking…' : 'Refresh' }}
        </button>
      </div>
    </header>

    <div class="ledger-frame">
      <table class="ledger">
        <colgroup>
          <col class="col-rule" />
          <col class="col-env" />
          <col class="col-status" />
          <col span="6" class="col-figure" />
          <col class="col-version" />
        </colgroup>
        <thead>
          <tr>
            <th><span class="visually-hidden">Link</span></th>
            <th scope="col">Environment</th>
            <th scope="col">Status</th>
            <th scope="col" class="figure">Ongoing</th>
            <th scope="col" class="figure">Next 24h</th>
            <th scope="col" class="figure">Done 24h</th>
            <th scope="col" class="figure">Errors 24h</th>
            <th scope="col" class="figure">Stalled</th>
            <th scope="col" class="figure">Failed 24h</th>
            <th scope="col" class="figure">Version</th>
          </tr>
        </thead>
        <tbody>
          @for (row of vm.rows; track row.environment.key) {
            <tr class="row row--{{ row.state }}">
              <td class="rule"></td>

              <th scope="row" class="env">
                <a class="env-name" [href]="'https://' + row.environment.host + '/app'" target="_blank" rel="noopener">
                  {{ row.environment.label }}
                </a>
                <span class="env-sub">
                  @if (row.overview; as overview) {
                    {{ overview.tenants.organizations }} orgs · {{ overview.tenants.users }} users
                  } @else {
                    {{ row.environment.host }}
                  }
                </span>
              </th>

              <td class="status">{{ statusLabel(row.state) }}</td>

              @if (row.overview; as overview) {
                <td class="figure" [class.figure--nil]="overview.calls.ongoing === 0">{{ overview.calls.ongoing }}</td>
                <td class="figure" [class.figure--nil]="overview.calls.upcomingNextDay === 0">{{ overview.calls.upcomingNextDay }}</td>
                <td class="figure" [class.figure--nil]="overview.calls.completedLastDay === 0">{{ overview.calls.completedLastDay }}</td>
                <td class="figure" [class.figure--nil]="overview.calls.erroredLastDay === 0" [class.figure--alert]="overview.calls.erroredLastDay > 0">
                  {{ overview.calls.erroredLastDay }}
                </td>
                <td
                  class="figure"
                  [class.figure--nil]="overview.processing.stalledJobRuns === 0"
                  [class.figure--alert]="overview.processing.stalledJobRuns > 0"
                >
                  {{ overview.processing.stalledJobRuns }}
                </td>
                <td
                  class="figure"
                  [class.figure--nil]="overview.processing.failedJobRunsLastDay === 0"
                  [class.figure--alert]="overview.processing.failedJobRunsLastDay > 0"
                >
                  {{ overview.processing.failedJobRunsLastDay }}
                </td>
                <td
                  class="figure version"
                  [class.version--drift]="row.versionDrift"
                  [title]="row.versionDrift ? 'Not the version most environments are running' : ''"
                >
                  {{ shortVersion(overview.version) }}
                </td>
              } @else {
                <td class="fallback" colspan="7">
                  <span class="fallback-direction">{{ direction(row.state) }}</span>
                  @if (row.state === 'signInRequired') {
                    <button type="button" class="button button--accent" (click)="signIn(row.environment)">Sign in</button>
                  } @else if (row.state === 'unreachable') {
                    <button type="button" class="button" (click)="retry(row.environment)">Retry</button>
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>

    <p class="footnote">
      Atlas reads each environment with your own session for that environment. Nothing is stored here — sign out of an environment and it goes dark.
    </p>
  </div>
}
